// src/pages/admin/AdminEventLeads.jsx
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase"; // client avec session admin connectée

export default function AdminEventLeads() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("new"); // filtre simple

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("event_leads")
        .select("id, created_at, fair, slot, name, email, org, status")
        .order("created_at", { ascending: false })
        .ilike("status", status === "all" ? "%" : status);
      if (error) console.error(error);
      setRows(data ?? []);
      setLoading(false);
    })();
  }, [status]);

  const updateStatus = async (id, next) => {
    const { error } = await supabase.from("event_leads").update({ status: next }).eq("id", id);
    if (!error) setRows((r) => r.map(x => x.id === id ? { ...x, status: next } : x));
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-serif mb-4">Leads salons</h1>
      <div className="flex gap-3 mb-4">
        {["new","contacted","scheduled","won","lost","all"].map(s => (
          <button key={s} className={`px-3 py-1 rounded border ${status===s?'bg-black text-white':'bg-white'}`}
            onClick={() => setStatus(s)}>{s}</button>
        ))}
      </div>

      {loading ? <p>Chargement…</p> : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left border-b">
              <th>Créé</th><th>Foire</th><th>Slot</th><th>Nom</th><th>Email</th><th>Org</th><th>Statut</th><th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.id} className="border-b">
                <td>{new Date(row.created_at).toLocaleString()}</td>
                <td>{row.fair}</td>
                <td>{row.slot || '-'}</td>
                <td>{row.name}</td>
                <td><a className="underline" href={`mailto:${row.email}`}>{row.email}</a></td>
                <td>{row.org || '-'}</td>
                <td>{row.status}</td>
                <td className="text-right">
                  <select defaultValue={row.status} onChange={(e)=>updateStatus(row.id, e.target.value)}
                          className="border rounded px-2 py-1">
                    {["new","contacted","scheduled","won","lost"].map(s=><option key={s}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
